import { Pipe, PipeTransform } from '@angular/core';
import { AlertViewModel } from 'apps/analytics-portal/src/app/models/alert-view-model';

@Pipe({
  name: 'sortAlerts',
  standalone: false,
})
export class SortAlerts implements PipeTransform {
  transform(alerts: [AlertViewModel]): [AlertViewModel] {
    return alerts.sort((a, b) => a.name.localeCompare(b.name));
  }
}
